import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Facebook, Instagram, YouTube } from '@mui/icons-material';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { routes } from "../../../helper/routes.js"
import './Css/Footer.css';

function Footer() {
  // REMOVED: window.location.href = 'mailto:info@edsider.com'; 
  // This was the cause of the popup loop.

  const currentYear = new Date().getFullYear();

  return (
    <div style={{ background: 'linear-gradient(to right, #d2cde8, #b58eb5)', borderRadius: '12px 12px 0 0', padding: '2rem 1rem' }}>
      <Container fluid>
        {/* Top Navigation Row */}
        <Row className="justify-content-between align-items-center text-center text-md-start mb-3">
          <Col xs={12} md={4} className="mb-3 mb-md-0 footer-pages">
            <div style={{ fontSize: '0.8rem', textAlign: 'start' }}>
              Powered by{' '}
              <a href="https://www.infyinnos.com/" target="_blank" rel="noopener noreferrer" className="nav-link-custom">
                <span className="fw-bold">Infinity Innovators (Pvt) Ltd</span><br />
              </a>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="d-flex justify-content-center align-items-center">
              <a href="">
                <img className="logo" src="https://landingpage4edsdev.blob.core.windows.net/images/edsiderlogo.png" alt="logo" />
              </a>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="footer-contact">
              <Row>
                <Col xs={12} md={12} className="eandn" >
                  <Nav className="privacy-footer">
                    <Nav.Link href={routes.terms_and_conditions_view} className="nav-link-custom terms" style={{ fontSize: '0.85rem' }}>
                      Terms of Service & Privacy Policy
                    </Nav.Link>
                  </Nav>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {/* <hr style={{ borderColor: '#ccc' }} /> */}

        {/* Bottom Footer Row */}
        <Row className="align-items-center text-center text-md-start mt-3">
          <Col xs={12} className="text-center mb-3 mb-md-0">
            <div style={{ fontSize: '0.8rem' }}>
               <small>© {currentYear} Edsider. All rights reserved.</small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;
